import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    // Here you could integrate with your backend/email service
    alert('Your message has been sent. Thank you!');
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: '',
    });
  };

  return (
    <div className='contact-container'>
      <h1>Contact Us</h1>
      <p>
        For any inquiries or support, please reach out to us at{' '}
        <a href='mailto:support@saef.app'>support@saef.app</a>.
      </p>

      <form className='contact-form' onSubmit={handleSubmit}>
        <div className='contact-row'>
          <div className='contact-field'>
            <label>First Name</label>
            <input
              type='text'
              name='firstName'
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className='contact-field'>
            <label>Last Name</label>
            <input
              type='text'
              name='lastName'
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className='contact-row'>
          <div className='contact-field'>
            <label>Phone Number</label>
            <input
              type='tel'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className='contact-field'>
            <label>Email</label>
            <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className='contact-field'>
          <label>Message</label>
          <textarea
            name='message'
            value={formData.message}
            onChange={handleChange}
            rows={5}
            required
          ></textarea>
        </div>

        <button type='submit' className='contact-submit-button'>
          Submit
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
